<template>
    <div class="care">
        <div class="list_list" v-loading="loading && page==1">
            <div class="list_in" v-if="!noData">
                <div v-for="(item,index) in dataList" :key="item.id">
                    <div class="left">
                        <i v-if="item.isNew == 1">NEW</i>
                        <p class="h1">{{ item.enterpriseName }}</p>
                        <div class="flag">
                            <span class="chukou" v-if="item.isExport == 1">出口</span>
                            <span class="chukou jinkou" v-if="item.isImport == 1">进口</span>
                            <span class="fl1" v-if="item.recentTrading == 1">低贸易量</span>
                            <span class="fl2" v-if="item.recentTrading == 2">中贸易量</span>
                            <span class="fl3" v-if="item.recentTrading == 3">高贸易量</span>
                        </div>
                        <p class="h2 onelinehidden">{{ item.exportCountry }}</p>
                        <p class="h3 onelinehidden">{{ item.productName }}</p>
                    </div>
                    <div class="right">
                        <button @click="todetail(item.id)">查看详情</button>
                        <span v-if="item.isCollect==1" @click="cancelFavor(item.id,index)"><img src="@/assets/img/star.png" alt="">已关注</span>
                    </div>
                </div>
            </div>
            <div class="no-data" v-else>
                <img src="@/assets/img/user/care_none.png" />暂无关注列表
            </div>
        </div>
        <div class="next-load" v-if="!noData && dataList.length>5">
            <span v-show="loading && page>1"><i class="el-icon-loading"></i>加载中...</span>
            <span v-show="isLast">已加载全部</span>
        </div>
        <popup ref="popup"></popup>
    </div>
</template>

<script>
import popup from "@/components/Popup";
export default {
    components: {
        popup
    },
    data() {
        return {
            page: 1,
            dataList: [],
            loading: false,
            isLast: false,
            noData: false,
        };
    },
    mounted() {
        this.getList();
        addEventListener("scroll", this.handleScroll, true); //监听函数
    },
    methods: {
        todetail(id) {
            this.$http.get("app/enterprise/info/" + id).then((res) => {
                if (res.data.code == 1) {
                    //您的试用次数已用完
                    this.$refs.popup.isvipshow(2);
                } else if (res.data.code == 0) {
                    this.$router.push({
                        path: "/home/detail",
                        query: {
                            id: id,
                        },
                    });
                }
            });
        },
        getList(state) {
            this.loading = true;
            let json = {
                limit: "10", //每页显示记录数
                page: this.page, //当前页码
                order: "desc" //排序方式
            };
            this.$http
                .get("/app/collect/list", {
                    params: json
                })
                .then(res => {
                    if (res.data.code == 0) {
                        this.loading = false;
                        this.dataList.push(...res.data.data.list);
                        if (this.dataList.length == 0) {
                            this.noData = true;
                        }
                        if (json.limit * this.page >= res.data.data.totalCount) {
                            this.isLast = true;
                        }
                    }
                });
        },
        cancelFavor(id, index) {
            this.$confirm("是否取消关注?", "操作确认", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
            }).then(() => {
                this.$http.get("/app/enterprise/follow/" + id).then(res => {
                    if (res.status == 200) {
                        this.dataList.splice(index, 1);
                    }
                });

            }).catch(() => { });
        },
        handleScroll() {
            let scrollTop =
                document.documentElement.scrollTop || document.body.scrollTop; //变量scrollTop是滚动条滚动时，距离顶部的距离
            let windowHeight =
                document.documentElement.clientHeight || document.body.clientHeight; //变量windowHeight是可视区的高度
            let scrollHeight =
                document.documentElement.scrollHeight || document.body.scrollHeight; //变量scrollHeight是滚动条的总高度
            var sum = Math.abs(Math.floor(scrollTop + windowHeight) - scrollHeight);
            if (!this.isLast && sum <= 1 && !this.loading) {
                this.page++;
                this.getList();
            }
        }
    },
    destroyed() {
        removeEventListener("scroll", this.handleScroll, true);
    }
};
</script>

<style lang="less" scoped>
.list_list {
    background: #fff;
    padding: 0 20px;

    .list_in {
        width: 100%;

        > div {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 26px 0;
            border-bottom: 1px solid #ebebeb;

            &:hover {
                background-color: #f8f8f8;
                border-bottom: 1px solid #fff;
                margin: 0 -20px;
                padding: 26px 20px;

                button {
                    background: none;
                    background-image: linear-gradient(
                            0deg,
                            #0063dd 0%,
                            #0072ff 100%
                        ),
                        linear-gradient(#edf5ff, #edf5ff);
                    background-blend-mode: normal, normal;
                    color: #fff !important;
                }
            }

            &:last-child {
                border: 0;

                &:hover {
                    border: 0;
                }
            }

            .left {
                width: 650px;
                position: relative;
                box-sizing: border-box;

                i {
                    display: block;
                    width: 40px;
                    height: 30px;
                    text-align: center;
                    line-height: 30px;
                    font-size: 12px;
                    background-color: #ff7070;
                    position: absolute;
                    top: 0;
                    left: 0px;
                    color: #fff;
                    border-radius: 10px 10px 10px 0;
                }

                .h1 {
                    width: 100%;
                    font-size: 22px;
                    font-weight: bold;
                    color: #4a4a4a;
                }

                .flag {
                    width: 100%;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    margin-top: 14px;

                    span {
                        color: #fff;
                        text-align: center;
                        line-height: 30px;
                        border-radius: 6px;
                    }

                    .chukou {
                        width: 60px;
                        height: 30px;
                        background-color: #e6edfe;
                        color: #2865ff;
                        margin-right: 10px;
                    }

                    .jinkou {
                        background: #e5fbed;
                        color: #4fc478;
                    }

                    span:last-child {
                        width: 100px;
                        height: 30px;
                        padding-left: 15px;
                    }

                    .fl1 {
                        background: url("../../assets/img/hot.png") #648fff
                            no-repeat 10px center;
                        background-size: 15px 15px;
                    }

                    .fl2 {
                        background: url("../../assets/img/hot.png") #ff9564
                            no-repeat 10px center;
                        background-size: 15px 15px;
                    }

                    .fl3 {
                        background: url("../../assets/img/hot.png") #ff7070
                            no-repeat 10px center;
                        background-size: 15px 15px;
                    }
                }

                .h2 {
                    font-size: 14px;
                    color: #909090;
                    margin-top: 18px;
                }

                .h3 {
                    font-size: 14px;
                    color: #989898;
                    margin-top: 5px;

                    s {
                        font-weight: bold;
                        color: #0058f8;
                    }
                }
            }

            .right {
                span {
                    cursor: pointer;
                    margin-top: 15px;
                    display: block;
                    text-align: center;

                    img {
                        display: inline-block;
                        vertical-align: middle;
                        margin-right: 5px;
                    }
                }

                button {
                    width: 150px;
                    height: 50px;
                    background-color: #edf5ff;
                    border-radius: 4px;
                    font-size: 18px;
                    font-weight: bold;
                    color: #0066e5;
                    text-align: center;

                    &:hover {
                        background: none;
                        background-image: linear-gradient(
                                0deg,
                                #0063dd 0%,
                                #0072ff 100%
                            ),
                            linear-gradient(#edf5ff, #edf5ff);
                        background-blend-mode: normal, normal;
                        color: #fff;
                    }
                }
            }
        }
    }

    .isshaixuan {
        width: 100%;

        img {
            max-width: 600px;
            display: block;
            margin: 0 auto;
        }
    }
}

.next-load {
    height: 40px;
    line-height: 40px;
    position: relative;
    font-size: 14px;
    text-align: center;
    color: #999;

    i {
        font-size: 22px;
        margin-right: 10px;
    }

    &::after {
        position: absolute;
        content: "";
        top: 19px;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: #ddd;
        z-index: 2;
    }

    span {
        padding: 0 30px;
        display: inline-block;
        background-color: #f5f5f5;
        position: relative;
        z-index: 10;
    }
}
</style>
